/*Auto-generated at pre-build.js*/ export class BuildDetails { public static readonly isoDate = '2026-11-04T16:12:25.206Z'; }